import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent, customizable, nullRender } from '../../../Utilities';
import { DefaultButton } from '../DefaultButton/DefaultButton';
var PrimaryButton = /** @class */ (function (_super) {
    tslib_1.__extends(PrimaryButton, _super);
    function PrimaryButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Set this BaseComponent._resolveComponentRef to false, bypassing resolution of componentRef.
         */
        _this._shouldUpdateComponentRef = false;
        return _this;
    }
    PrimaryButton.prototype.render = function () {
        return React.createElement(DefaultButton, tslib_1.__assign({}, this.props, { primary: true, onRenderDescription: nullRender }));
    };
    PrimaryButton = tslib_1.__decorate([
        customizable('PrimaryButton', ['theme', 'styles'])
    ], PrimaryButton);
    return PrimaryButton;
}(BaseComponent));
export { PrimaryButton };
//# sourceMappingURL=PrimaryButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Button/PrimaryButton/PrimaryButton.js
// module id = 82
// module chunks = 0